var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtAccountSuspended = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F8B24F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m116.5 30.5 13.5 12M102.5 52l18 3"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 166.5,
  cy: 88.5,
  r: 43.5,
  fill: "#911D0D"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 161.5,
  cy: 85.5,
  r: 43.5,
  fill: "#F23015"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#223B90",
  d: "M197.053 110.325v-2.145c0-5.372 1.522-8.947 8.947-8.947 7.938 0 8.946 3.869 8.946 7.242 0 .715.569 1.283 1.284 1.283.715 0 1.283-.568 1.283-1.283 0-6.508-3.868-9.808-11.513-9.808-10.322 0-11.514 6.563-11.514 11.513v2.292a21.73 21.73 0 0 1 2.567-.147ZM206 120.808a2.988 2.988 0 1 0 0-5.977 2.988 2.988 0 0 0 0 5.977Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M214.525 106.307h-17.05c-7.517 0-9.808 2.291-9.808 9.808v3.41c0 7.517 2.291 9.808 9.808 9.808h17.05c7.517 0 9.808-2.291 9.808-9.808v-3.41c0-7.517-2.291-9.808-9.808-9.808ZM206 123.357a5.544 5.544 0 0 1-5.537-5.537 5.544 5.544 0 0 1 5.537-5.537 5.544 5.544 0 0 1 5.537 5.537 5.544 5.544 0 0 1-5.537 5.537Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M161.51 80.463c5.927 0 10.732-4.804 10.732-10.731S167.437 59 161.51 59s-10.732 4.805-10.732 10.732 4.805 10.731 10.732 10.731ZM161.51 85.83c-10.753 0-19.51 7.211-19.51 16.097 0 .601.472 1.073 1.073 1.073h36.874c.601 0 1.073-.472 1.073-1.073 0-8.886-8.757-16.098-19.51-16.098Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F8B24F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m143.5 39.5 2-13"
})));
export default SvgArtAccountSuspended;